import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";

const Blog10 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/966c1811-0602-4cd1-d721-696a2ed7bd00/public" //Init_Blog10.webp
                alt="Img"
                loading="lazy"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <h1
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                <span className="font-semibold">
                  Quantum Computing Is Closer <br className="hidden md:block" />{" "}
                  Than You Think: What Businesses{" "}
                  <br className="hidden md:block" />
                  Need to Prepare for Now
                </span>
              </h1>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            Once a sci-fi fantasy, quantum computing is now a commercial
            reality. With advances bringing commercial applications closer than
            ever, governments and businesses are investing heavily in quantum
            research. Companies must begin preparing now.
          </p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p className="font-bold">Why Quantum Computing Matters</p>

            <p>
              • Exponential Speed: Problems that would take centuries for
              traditional computers to solve can be solved by quantum
              processors.
            </p>

            <p>
              • Impact on Cryptography: Due to quantum algorithms, conventional
              encryption techniques might soon become outdated.
            </p>

            <p>
              • Data-Intensive Industries: Quantum optimisation has enormous
              potential benefits for the healthcare, logistics, and financial
              sectors.
            </p>
          </div>

          <div className="space-y-3">
            <p className="font-bold">Steps Businesses Can Take Now</p>

            <p>
              1. Adopt Quantum-Safe Encryption: Before it's too late, switch to
              post-quantum cryptography standards.
            </p>

            <p>
              2. Keep Up: To predict disruption, keep up with vendor updates and
              quantum research.
            </p>

            <p>
              3. Partnerships with Tech Leaders: Work together with research
              institutes and startups that are interested in quantum technology.
            </p>

            <p>
              4. Internal Training: To guarantee preparedness, upskill teams in
              quantum fundamentals.
            </p>
          </div>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <p>
            Many people are unaware of how close quantum computing is. Companies
            will gain a competitive edge in the upcoming wave of technological
            disruption if they take immediate action by implementing quantum-
            safe measures and investigating pilot projects.
          </p>

          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>October 23, 2025 ∙ 5 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog10;
